import { Box } from "arkh";

export function IconLayout(props: { icons: React.ReactNode[] }) {
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1,
        flexGrow: 0,
        overflow: "hidden",
      }}
    >
      {props.icons.map((icon, i) => (
        <Box key={i} spaceLeft={i === 0 ? "xsmall" : "small"}>
          {icon}
        </Box>
      ))}
    </Box>
  );
}
